export function CustomChannelApp() {
  return {
    isSelectorOpen: false,
    toggleSelector() {
      this.isSelectorOpen = !this.isSelectorOpen;
    },
    closeSelector(event) {
      const isSelector =
        this.$refs.customChannel.contains(event.target) ||
        this.$refs.customChannel === event.target;

      if (isSelector) return;

      this.isSelectorOpen = false;
    },
    handleOutsideClick(event) {
      this.closeSelector(event);
    },
    mounted() {
      document.addEventListener('click', this.handleOutsideClick);
    },
    unmounted() {
      document.removeEventListener('click', this.handleOutsideClick);
    },
  };
}
